import { type NodeViewProps, useEditorState } from '@tiptap/react'
import { NODE_CONFIG_KEY } from '#src/components/rich-text-editor/conditional-display/NodeConfigExtension.ts'

// Whether the configuration panel beside the editor is open on this node.
export function useIsNodeConfiguring({
  editor,
  getPos,
}: Pick<NodeViewProps, 'editor' | 'getPos'>): boolean {
  return (
    useEditorState({
      editor,
      selector: ({ editor: current }) => {
        const pos = NODE_CONFIG_KEY.getState(current.state)?.pos
        if (typeof pos !== 'number') {
          return false
        }
        // A change that replaces the node (wrapping it in a section) runs
        // this once more for the old view, which ProseMirror has already
        // detached: its getPos throws rather than returning undefined.
        try {
          return pos === getPos()
        } catch {
          return false
        }
      },
    }) ?? false
  )
}

// The node being configured: outlined and glowing in the accent green.
export const CONFIGURING_NODE_CLASS =
  'ring-1 ring-[#269b2e] shadow-[0_0_4px_0_#269b2e]'
